<img src="/assets/icons/video-platforms/youtube.svg" alt="youtube" (click)="oauth2LoginRedirect('google')"/>
<!--<img src="/assets/icons/video-platforms/gg.svg" alt="gg"/>-->
<img src="/assets/icons/video-platforms/twitch.svg" alt="twitch" (click)="oauth2LoginRedirect('twitch')"/>
